import { render, staticRenderFns } from "./IFIndustrySummary.vue?vue&type=template&id=5544bf09"
import script from "./IFIndustrySummary.vue?vue&type=script&lang=js"
export * from "./IFIndustrySummary.vue?vue&type=script&lang=js"
import style0 from "./IFIndustrySummary.vue?vue&type=style&index=0&id=5544bf09&prod&scope=true&lang=css"
import style1 from "./IFIndustrySummary.vue?vue&type=style&index=1&id=5544bf09&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports